<template>
  <div class="mini-post-card">
    <div class="mini-post-content">
      <!-- Avatar -->
      <img
        :src="getAvatarImage(post.profile?.thumbnail_url) || '/placeholder.png'"
        :alt="post.profile?.name"
        class="mini-post-avatar"
        @click="$emit('view-profile')"
      >

      <!-- Content -->
      <div class="mini-post-body">
        <div class="mini-post-header">
          <div class="mini-post-meta">
            <h4 class="mini-post-author" @click="$emit('view-profile')">
              {{ post.profile?.name }}
            </h4>
            <Heart v-if="showLoveBadge" class="mini-post-love-badge" />
            <span v-if="post.post_type === 'exploration'" class="mini-post-type-badge">
              🧭 Exploring
            </span>
          </div>
          <time class="mini-post-time">{{ formatTime(post.created_at) }}</time>
        </div>

        <p class="mini-post-text">
          {{ post.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Heart } from 'lucide-vue-next'
import { getAvatarImage } from '../../lib/imageUtils'

defineProps({
  post: Object,
  showLoveBadge: Boolean
})

defineEmits(['view-profile'])

function formatTime(dateString) {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now - date
  const diffMins = Math.floor(diffMs / (1000 * 60))

  if (diffMins < 1) return 'just now'
  if (diffMins < 60) return `${diffMins}m`

  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h`

  return date.toLocaleDateString()
}
</script>
